export const GtmService = {
    /**
     * Pushes an event to the dataLayer.
     * @param {string} event
     * @param {object} data
     */
    pushToDataLayer: (event, data) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event,
            ...data
        });
    },

    /**
     * Logs a view_item event.
     * @param {object} product - The product details
     */
    logViewItem: (product) => {
        if (!product) return;

        GtmService.pushToDataLayer('view_item', {
            items: [{
                item_id: product.id || product.code,
                item_name: product.name,
                item_category: product.category || product.manufacturer, // Fallback if category is missing
                price: product.price?.sellingPrice || product.price?.value || 0,
                quantity: 1
            }]
        });
    },

    /**
     * Logs an add_to_cart event.
     * @param {object} product - The product details
     * @param {number} quantity - The quantity added
     * @param {object} price - The price details applied
     */
    logAddToCart: (product, quantity, price) => {
        if (!product) return;

        GtmService.pushToDataLayer('add_to_cart', {
            items: [{
                item_id: product.code || product.id,
                item_name: product.name,
                item_category: product.category || product.manufacturer,
                price: price?.sellingPrice || product.price?.sellingPrice || 0,
                quantity: quantity
            }]
        });
    },

    /**
     * Logs a begin_checkout event.
     * @param {object} cart - The current cart state
     */
    logBeginCheckout: (cart) => {
        if (!cart || !cart.products) return;

        const items = cart.products.map(item => ({
            item_id: item.code || item.id,
            item_name: item.name,
            item_category: item.category || item.manufacturer,
            price: item.sellingPrice || item.price?.sellingPrice || 0,
            quantity: item.quantity
        }));

        GtmService.pushToDataLayer('begin_checkout', { items });
    },

    /**
     * Logs a purchase event.
     * @param {string} transactionId
     * @param {number} total
     * @param {number} tax
     * @param {object[]} cartItems
     */
    logPurchase: (transactionId, total, tax, cartItems) => {
        const items = cartItems.map(item => ({
            item_id: item.code || item.id,
            item_name: item.name,
            item_category: item.category || item.manufacturer,
            price: item.sellingPrice || item.price?.sellingPrice || 0,
            quantity: item.quantity
        }));

        GtmService.pushToDataLayer('purchase', {
            transaction_id: transactionId,
            value: total,
            currency: 'EUR',
            tax: tax,
            shipping: 0, // Assuming 0 for now as per req
            items: items
        });
    }
};
